import firebase, { boardsCollection } from "../firebase";
import { v4 as uuidv4 } from "uuid";
import { getCurrentUserId , logError} from "./../util/common";

class BoardService {
  constructor() {}

  generateColumnsObject(columnNamesArray) {
    const update = {};
    columnNamesArray.forEach((columnName, index) => {
      update[uuidv4()] = {
        // Default values
        title: columnName,
        index: index,
        cards: {},
        created_at: firebase.firestore.FieldValue.serverTimestamp(),
        created_by: getCurrentUserId(),
        updated_at: firebase.firestore.FieldValue.serverTimestamp(),
        updated_by: getCurrentUserId(),
      };
    });
    return update;
  }

  async createBoard(boardName, columnsNamesArray = []) {
    let columns = {};
    if (
      columnsNamesArray &&
      Array.isArray(columnsNamesArray) &&
      columnsNamesArray.length > 0
    ) {
      columns = this.generateColumnsObject(columnsNamesArray);
    }
    const boardPayoload = {
      name: boardName,
      id: uuidv4(),
      created_at: firebase.firestore.FieldValue.serverTimestamp(),
      updated_at: firebase.firestore.FieldValue.serverTimestamp(),
      created_by: getCurrentUserId(),
      updated_by: getCurrentUserId(),
      columns: columns,
    };

    return boardsCollection.add(boardPayoload);
  }

  async updateBoard(boardFirebaseID, columnsFieldData) {
    const boardDocRef = boardsCollection.doc(boardFirebaseID);

    firebase
      .firestore()
      .runTransaction((transaction) => {
        return transaction.get(boardDocRef).then((boardDoc) => {
          if (!boardDoc.exists) {
            throw "Document does not exist!";
          }
          const dbBoardJSON = boardDoc.data();
          if (dbBoardJSON.id !== null) {
            const update = {};
            update[`columns`] = columnsFieldData;
            return transaction.update(boardDocRef, update);
          } else {
            throw "Update board failed. The board have changed since your last update";
          }
        });
      })
      .then(() => {
        console.log("Update Board Transaction successfully committed!");
      })
      .catch((error) => {
        console.error("Update Board Transaction failed: ", error);
        logError(error);
      });
  }
}

export default new BoardService();
